export function lowercaseFirstLetter(val: string): string {
  return val.charAt(0).toLowerCase() + val.slice(1);
}

export  function uppercaseFirstLetter(val: string): string {
  return val.charAt(0).toUpperCase() + val.slice(1);
}
